import produce from 'immer';
import {
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOAD_DATA_SUCCESS,
  LOGOUT_USER,
  RESET_DATA,
  SET_PC_LEVEL_SUCCEESS,
  SET_PC_STATUS_SUCCESS,
  SET_PIN_SUCCESS,
} from './action-types';
import { ProfileDataType, ParentalControlType, SubscriptionType } from './types';

export type ProfileStateType = {
  isLoggedIn: boolean;
  data: ProfileDataType | null;
  error: string;
  parentalControl: ParentalControlType | null;
  subscriptions: SubscriptionType[];
};

const initialState: ProfileStateType = {
  isLoggedIn: false,
  data: null,
  error: null,
  parentalControl: null,
  subscriptions: [],
};

export default produce((draft: ProfileStateType, action) => {
  switch (action.type) {
    case LOGIN_USER_SUCCESS:
      draft.isLoggedIn = true;
      draft.error = null;
      break;
    case LOGIN_USER_ERROR:
      draft.isLoggedIn = false;
      draft.error = action.payload;
      break;
    case LOAD_DATA_SUCCESS: {
      const { data, parentalControl, subscriptions } = action.payload;
      draft.data = data;
      draft.parentalControl = parentalControl;
      draft.subscriptions = subscriptions;
      break;
    }
    case SET_PC_LEVEL_SUCCEESS: {
      const { level } = action.payload;

      draft.parentalControl.pc_level = level;
      break;
    }
    case SET_PC_STATUS_SUCCESS: {
      const { status } = action.payload;

      draft.parentalControl.pc = status;
      break;
    }

    case SET_PIN_SUCCESS: {
      const { pin } = action.payload;

      draft.data.pc_pin = pin;
      break;
    }
    case RESET_DATA:
    case LOGOUT_USER:
      return { ...initialState };
    default:
    // nothing
  }
  return draft;
}, initialState);
